import HtmlElement from '../../../../../../ig_template/Resources/Public/Src/Js/Elements/HtmlElement';

/**
 * Map
 *
 * @class
 * @augments HtmlElement
 */
export default class Map extends HtmlElement {
	/**
	 * @constructor
	 */
	constructor($element) {
		super($element);

		this._$map = $element.find('.ig-map');

		this._id = this._$map.attr('id');
		this._uid = this._$map.data('uid');
		this._map = null;
		this._mapSettings = {};
		this._markers = [];
		this._infoWindows = [];
		this._currentInfoWindow = null;
	}

	/**
	 * Sets the map settings
	 *
	 * @return void
	 */
	setMapSettings(mapSettings) {
		this._mapSettings = mapSettings;
	}

	/**
	 * Initializes the map
	 *
	 * @return void
	 */
	initialize() {
		const mapElement = document.getElementById(this._id);

		this._map = new google.maps.Map(
			mapElement,
			this._getParsedMapSettings()
		);

		$(mapElement).data('googleMap', this._map);

		if (this.$element.find('.ig-map-info-window').length) {
			this._addInfoWindows();
		}

		if (this._mapSettings['markersData']) {
			this._addMarkers();
			this._fitBounds();
		}

		if (this._mapSettings['maxHeight'] > 0) {
			this._setMaxHeight();
		}
	}

	/**
	 * Returns the parsed map settings
	 *
	 * @return array parsedSettings
	 */
	_getParsedMapSettings() {
		let parsedSettings = this._mapSettings;

		if (parsedSettings['styles']) {
			parsedSettings['styles'] = JSON.parse(parsedSettings['styles']);
		}

		return parsedSettings;
	}

	_addMarkers() {
		const map = this._map;

		this._mapSettings['markersData'].forEach((marker) => {
			let icon = {};

			if (this._mapSettings['markerIcon']) {
				icon = {
					url: this._mapSettings['markerIcon'],
					size: new google.maps.Size(27, 43)
				};
			}

			let mapMarker = new google.maps.Marker({
				map,
				...marker,
				icon
			});

			mapMarker.addListener('click', () => {
				map.panTo(mapMarker.getPosition());
			});

			this._markers[marker.uid] = mapMarker;

			mapMarker.addListener('click', () => {
				this._openInfoWindow(mapMarker, marker.uid);
			});
		});

		this._mapSettings['markersData'] = undefined;
		$(this._map.getDiv()).data('googleMapMarkers', this._markers);

		this._mapMarkersAdded();
	}

	_mapMarkersAdded() {}

	_openInfoWindow(mapMarker, markerUid) {
		const infoWindow = this._getInfoWindowByUid(markerUid);

		if (this._currentInfoWindow) {
			this._currentInfoWindow.close();
		}

		infoWindow.open(this._map, mapMarker);
		this._currentInfoWindow = infoWindow;
	}

	_fitBounds() {
		let bounds = new google.maps.LatLngBounds();

		this._markers.forEach((marker) => {
			bounds.extend(marker.getPosition());
		});

		this._map.fitBounds(bounds);
	}

	_addInfoWindows() {
		this.$element.find('.ig-map-info-window').each((i, el) => {
			const $infoWindow = $(el);
			this._infoWindows[$infoWindow.data('uid')] = new google.maps.InfoWindow({
				content: $infoWindow.html()
			});

			$infoWindow.remove();
		});
	}

	_getInfoWindowByUid(uid) {
		return this._infoWindows[uid];
	}

	_setMaxHeight() {
		this._$map.css('padding-bottom', `${this._mapSettings['maxHeight']}%`);
	}
}
